import { render, staticRenderFns } from "./DoronPurchase.vue?vue&type=template&id=3d7e0883&scoped=true&"
import script from "./DoronPurchase.vue?vue&type=script&lang=js&"
export * from "./DoronPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7e0883",
  null
  
)

export default component.exports